"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Template Service API Docs
 * The template service is intended to host templates. A template defines a DDB data structure of asset types, parameter types, and the  relationships between them. These are initially created in draft,  and when published become immutable and available for use to create collections  within the parameter service.
 *
 * The version of the OpenAPI document: 0.31.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateApi = exports.TemplateApiFactory = exports.TemplateApiFp = exports.TemplateApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * TemplateApi - axios parameter creator
 * @export
 */
var TemplateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete an existing asset placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetPlaceholder: function (templateId, assetPlaceholderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAssetPlaceholder', 'templateId', templateId);
                            // verify required parameter 'assetPlaceholderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAssetPlaceholder', 'assetPlaceholderId', assetPlaceholderId);
                            localVarPath = "/templates/{template_id}/asset_placeholders/{asset_placeholder_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)))
                                .replace("{".concat("asset_placeholder_id", "}"), encodeURIComponent(String(assetPlaceholderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an existing parameter placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterPlaceholder: function (templateId, parameterPlaceholderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteParameterPlaceholder', 'templateId', templateId);
                            // verify required parameter 'parameterPlaceholderId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteParameterPlaceholder', 'parameterPlaceholderId', parameterPlaceholderId);
                            localVarPath = "/templates/{template_id}/parameter_placeholders/{parameter_placeholder_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)))
                                .replace("{".concat("parameter_placeholder_id", "}"), encodeURIComponent(String(parameterPlaceholderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an existing draft template. Note - requires Application  Admin privileges.
         * @summary Delete a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: function (templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTemplate', 'templateId', templateId);
                            localVarPath = "/templates/{template_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns asset placeholders related to a template
         * @summary Get all asset placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'name'} [sortBy] Field by which to sort asset placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetPlaceholders', 'templateId', templateId);
                            localVarPath = "/templates/{template_id}/asset_placeholders"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * By default returns all directions within the database
         * @summary Returns all directions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirections: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/directions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns parameter placeholders related to a template
         * @summary Get all parameter placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'direction_id' | 'asset_placeholder_id'} [sortBy] Field by which to sort parameter placeholders
         * @param {object} [assetPlaceholderId] The asset_placeholder_id to filter parameter placeholders by
         * @param {object} [directionId] The direction_id to filter parameter placeholders by
         * @param {boolean} [optional] Boolean value to filter for optional/required parameter placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, assetPlaceholderId, directionId, optional, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('getParameterPlaceholders', 'templateId', templateId);
                            localVarPath = "/templates/{template_id}/parameter_placeholders"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (assetPlaceholderId !== undefined) {
                                localVarQueryParameter['asset_placeholder_id'] = assetPlaceholderId;
                            }
                            if (directionId !== undefined) {
                                localVarQueryParameter['direction_id'] = directionId;
                            }
                            if (optional !== undefined) {
                                localVarQueryParameter['optional'] = optional;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * By default returns all published, non-deleted templates. View drafts with the `show_drafts` query parameter.
         * @summary Returns all templates
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name' | 'created_at'} [sortBy] Field by which to sort templates
         * @param {string} [createdBy]
         * @param {Array<string>} [keyAssetTypeId] The asset type for the key asset placeholder identified for the template
         * @param {Array<string>} [keyAssetSubTypeId] The asset sub type for the key asset placeholder identified for the template
         * @param {Array<string>} [templateId]
         * @param {Array<string>} [projectId]
         * @param {boolean} [showDrafts]
         * @param {boolean} [showPublished]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates: function (order, pageLimit, after, before, showActive, showDeleted, sortBy, createdBy, keyAssetTypeId, keyAssetSubTypeId, templateId, projectId, showDrafts, showPublished, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/templates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (createdBy !== undefined) {
                                localVarQueryParameter['created_by'] = createdBy;
                            }
                            if (keyAssetTypeId) {
                                localVarQueryParameter['key_asset_type_id'] = keyAssetTypeId;
                            }
                            if (keyAssetSubTypeId) {
                                localVarQueryParameter['key_asset_sub_type_id'] = keyAssetSubTypeId;
                            }
                            if (templateId) {
                                localVarQueryParameter['template_id'] = templateId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (showDrafts !== undefined) {
                                localVarQueryParameter['show_drafts'] = showDrafts;
                            }
                            if (showPublished !== undefined) {
                                localVarQueryParameter['show_published'] = showPublished;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the name / description /count / key status of an existing asset  placeholder. Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {PatchAssetPlaceholderBody} patchAssetPlaceholderBody Asset placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetPlaceholder: function (templateId, assetPlaceholderId, patchAssetPlaceholderBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetPlaceholder', 'templateId', templateId);
                            // verify required parameter 'assetPlaceholderId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetPlaceholder', 'assetPlaceholderId', assetPlaceholderId);
                            // verify required parameter 'patchAssetPlaceholderBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetPlaceholder', 'patchAssetPlaceholderBody', patchAssetPlaceholderBody);
                            localVarPath = "/templates/{template_id}/asset_placeholders/{asset_placeholder_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)))
                                .replace("{".concat("asset_placeholder_id", "}"), encodeURIComponent(String(assetPlaceholderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchAssetPlaceholderBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the direction_id / optional field of an existing parameter placeholder.  Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {PatchParameterPlaceholderBody} patchParameterPlaceholderBody Parameter placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterPlaceholder: function (templateId, parameterPlaceholderId, patchParameterPlaceholderBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterPlaceholder', 'templateId', templateId);
                            // verify required parameter 'parameterPlaceholderId' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterPlaceholder', 'parameterPlaceholderId', parameterPlaceholderId);
                            // verify required parameter 'patchParameterPlaceholderBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterPlaceholder', 'patchParameterPlaceholderBody', patchParameterPlaceholderBody);
                            localVarPath = "/templates/{template_id}/parameter_placeholders/{parameter_placeholder_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)))
                                .replace("{".concat("parameter_placeholder_id", "}"), encodeURIComponent(String(parameterPlaceholderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchParameterPlaceholderBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update the name or description of an existing draft template. Note - requires Application Admin  privileges.
         * @summary Update a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PatchTemplateBody} patchTemplateBody Template body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTemplate: function (templateId, patchTemplateBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('patchTemplate', 'templateId', templateId);
                            // verify required parameter 'patchTemplateBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchTemplate', 'patchTemplateBody', patchTemplateBody);
                            localVarPath = "/templates/{template_id}"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchTemplateBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add new asset placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new asset placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostAssetPlaceholdersBody} postAssetPlaceholdersBody The asset placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetPlaceholders: function (templateId, postAssetPlaceholdersBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetPlaceholders', 'templateId', templateId);
                            // verify required parameter 'postAssetPlaceholdersBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetPlaceholders', 'postAssetPlaceholdersBody', postAssetPlaceholdersBody);
                            localVarPath = "/templates/{template_id}/asset_placeholders"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetPlaceholdersBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add new parameter placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new parameter placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostParameterPlaceholdersBody} postParameterPlaceholdersBody The parameter placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterPlaceholders: function (templateId, postParameterPlaceholdersBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterPlaceholders', 'templateId', templateId);
                            // verify required parameter 'postParameterPlaceholdersBody' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterPlaceholders', 'postParameterPlaceholdersBody', postParameterPlaceholdersBody);
                            localVarPath = "/templates/{template_id}/parameter_placeholders"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postParameterPlaceholdersBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new template as a draft by default (published_at field set to null). The current user will be set as the creator of the template. Note - requires Application Admin privileges.
         * @summary Create a new draft template (Application Admin only)
         * @param {Array<PostTemplateBody>} postTemplateBody Template body to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTemplate: function (postTemplateBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postTemplateBody' is not null or undefined
                            (0, common_1.assertParamExists)('postTemplate', 'postTemplateBody', postTemplateBody);
                            localVarPath = "/templates";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postTemplateBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Publishes an existing draft template, making it immutable and available  for use. Note - no request body is required for this endpoint.  Note - requires Application Admin privileges.
         * @summary Publish a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishTemplate: function (templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('publishTemplate', 'templateId', templateId);
                            localVarPath = "/templates/{template_id}/publish"
                                .replace("{".concat("template_id", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TemplateApiAxiosParamCreator = TemplateApiAxiosParamCreator;
/**
 * TemplateApi - functional programming interface
 * @export
 */
var TemplateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TemplateApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete an existing asset placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetPlaceholder: function (templateId, assetPlaceholderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAssetPlaceholder(templateId, assetPlaceholderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing parameter placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterPlaceholder: function (templateId, parameterPlaceholderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteParameterPlaceholder(templateId, parameterPlaceholderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an existing draft template. Note - requires Application  Admin privileges.
         * @summary Delete a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTemplate(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns asset placeholders related to a template
         * @summary Get all asset placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'name'} [sortBy] Field by which to sort asset placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetPlaceholders(templateId, order, pageLimit, after, before, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * By default returns all directions within the database
         * @summary Returns all directions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirections: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDirections(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns parameter placeholders related to a template
         * @summary Get all parameter placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'direction_id' | 'asset_placeholder_id'} [sortBy] Field by which to sort parameter placeholders
         * @param {object} [assetPlaceholderId] The asset_placeholder_id to filter parameter placeholders by
         * @param {object} [directionId] The direction_id to filter parameter placeholders by
         * @param {boolean} [optional] Boolean value to filter for optional/required parameter placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, assetPlaceholderId, directionId, optional, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParameterPlaceholders(templateId, order, pageLimit, after, before, sortBy, assetPlaceholderId, directionId, optional, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * By default returns all published, non-deleted templates. View drafts with the `show_drafts` query parameter.
         * @summary Returns all templates
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name' | 'created_at'} [sortBy] Field by which to sort templates
         * @param {string} [createdBy]
         * @param {Array<string>} [keyAssetTypeId] The asset type for the key asset placeholder identified for the template
         * @param {Array<string>} [keyAssetSubTypeId] The asset sub type for the key asset placeholder identified for the template
         * @param {Array<string>} [templateId]
         * @param {Array<string>} [projectId]
         * @param {boolean} [showDrafts]
         * @param {boolean} [showPublished]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates: function (order, pageLimit, after, before, showActive, showDeleted, sortBy, createdBy, keyAssetTypeId, keyAssetSubTypeId, templateId, projectId, showDrafts, showPublished, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTemplates(order, pageLimit, after, before, showActive, showDeleted, sortBy, createdBy, keyAssetTypeId, keyAssetSubTypeId, templateId, projectId, showDrafts, showPublished, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update the name / description /count / key status of an existing asset  placeholder. Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {PatchAssetPlaceholderBody} patchAssetPlaceholderBody Asset placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetPlaceholder: function (templateId, assetPlaceholderId, patchAssetPlaceholderBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAssetPlaceholder(templateId, assetPlaceholderId, patchAssetPlaceholderBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update the direction_id / optional field of an existing parameter placeholder.  Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {PatchParameterPlaceholderBody} patchParameterPlaceholderBody Parameter placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterPlaceholder: function (templateId, parameterPlaceholderId, patchParameterPlaceholderBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchParameterPlaceholder(templateId, parameterPlaceholderId, patchParameterPlaceholderBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update the name or description of an existing draft template. Note - requires Application Admin  privileges.
         * @summary Update a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PatchTemplateBody} patchTemplateBody Template body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTemplate: function (templateId, patchTemplateBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchTemplate(templateId, patchTemplateBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add new asset placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new asset placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostAssetPlaceholdersBody} postAssetPlaceholdersBody The asset placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetPlaceholders: function (templateId, postAssetPlaceholdersBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetPlaceholders(templateId, postAssetPlaceholdersBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Add new parameter placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new parameter placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostParameterPlaceholdersBody} postParameterPlaceholdersBody The parameter placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterPlaceholders: function (templateId, postParameterPlaceholdersBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postParameterPlaceholders(templateId, postParameterPlaceholdersBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new template as a draft by default (published_at field set to null). The current user will be set as the creator of the template. Note - requires Application Admin privileges.
         * @summary Create a new draft template (Application Admin only)
         * @param {Array<PostTemplateBody>} postTemplateBody Template body to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTemplate: function (postTemplateBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postTemplate(postTemplateBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Publishes an existing draft template, making it immutable and available  for use. Note - no request body is required for this endpoint.  Note - requires Application Admin privileges.
         * @summary Publish a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishTemplate: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.publishTemplate(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TemplateApiFp = TemplateApiFp;
/**
 * TemplateApi - factory interface
 * @export
 */
var TemplateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TemplateApiFp)(configuration);
    return {
        /**
         * Delete an existing asset placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssetPlaceholder: function (templateId, assetPlaceholderId, options) {
            return localVarFp.deleteAssetPlaceholder(templateId, assetPlaceholderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing parameter placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
         * @summary Delete an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterPlaceholder: function (templateId, parameterPlaceholderId, options) {
            return localVarFp.deleteParameterPlaceholder(templateId, parameterPlaceholderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an existing draft template. Note - requires Application  Admin privileges.
         * @summary Delete a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: function (templateId, options) {
            return localVarFp.deleteTemplate(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns asset placeholders related to a template
         * @summary Get all asset placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'name'} [sortBy] Field by which to sort asset placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, options) {
            return localVarFp.getAssetPlaceholders(templateId, order, pageLimit, after, before, sortBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * By default returns all directions within the database
         * @summary Returns all directions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirections: function (options) {
            return localVarFp.getDirections(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns parameter placeholders related to a template
         * @summary Get all parameter placeholders related to a template
         * @param {object} templateId ID of the template
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'direction_id' | 'asset_placeholder_id'} [sortBy] Field by which to sort parameter placeholders
         * @param {object} [assetPlaceholderId] The asset_placeholder_id to filter parameter placeholders by
         * @param {object} [directionId] The direction_id to filter parameter placeholders by
         * @param {boolean} [optional] Boolean value to filter for optional/required parameter placeholders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameterPlaceholders: function (templateId, order, pageLimit, after, before, sortBy, assetPlaceholderId, directionId, optional, options) {
            return localVarFp.getParameterPlaceholders(templateId, order, pageLimit, after, before, sortBy, assetPlaceholderId, directionId, optional, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * By default returns all published, non-deleted templates. View drafts with the `show_drafts` query parameter.
         * @summary Returns all templates
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name' | 'created_at'} [sortBy] Field by which to sort templates
         * @param {string} [createdBy]
         * @param {Array<string>} [keyAssetTypeId] The asset type for the key asset placeholder identified for the template
         * @param {Array<string>} [keyAssetSubTypeId] The asset sub type for the key asset placeholder identified for the template
         * @param {Array<string>} [templateId]
         * @param {Array<string>} [projectId]
         * @param {boolean} [showDrafts]
         * @param {boolean} [showPublished]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates: function (order, pageLimit, after, before, showActive, showDeleted, sortBy, createdBy, keyAssetTypeId, keyAssetSubTypeId, templateId, projectId, showDrafts, showPublished, options) {
            return localVarFp.getTemplates(order, pageLimit, after, before, showActive, showDeleted, sortBy, createdBy, keyAssetTypeId, keyAssetSubTypeId, templateId, projectId, showDrafts, showPublished, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the name / description /count / key status of an existing asset  placeholder. Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing asset placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} assetPlaceholderId ID of the asset placeholder
         * @param {PatchAssetPlaceholderBody} patchAssetPlaceholderBody Asset placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAssetPlaceholder: function (templateId, assetPlaceholderId, patchAssetPlaceholderBody, options) {
            return localVarFp.patchAssetPlaceholder(templateId, assetPlaceholderId, patchAssetPlaceholderBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the direction_id / optional field of an existing parameter placeholder.  Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
         * @summary Patch an existing parameter placeholder (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {object} parameterPlaceholderId ID of the parameter placeholder
         * @param {PatchParameterPlaceholderBody} patchParameterPlaceholderBody Parameter placeholder body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchParameterPlaceholder: function (templateId, parameterPlaceholderId, patchParameterPlaceholderBody, options) {
            return localVarFp.patchParameterPlaceholder(templateId, parameterPlaceholderId, patchParameterPlaceholderBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the name or description of an existing draft template. Note - requires Application Admin  privileges.
         * @summary Update a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PatchTemplateBody} patchTemplateBody Template body to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTemplate: function (templateId, patchTemplateBody, options) {
            return localVarFp.patchTemplate(templateId, patchTemplateBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add new asset placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new asset placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostAssetPlaceholdersBody} postAssetPlaceholdersBody The asset placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAssetPlaceholders: function (templateId, postAssetPlaceholdersBody, options) {
            return localVarFp.postAssetPlaceholders(templateId, postAssetPlaceholdersBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add new parameter placeholders for a template to the database.  Note - requires Application Admin privileges.
         * @summary Post a new parameter placeholder to a template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {PostParameterPlaceholdersBody} postParameterPlaceholdersBody The parameter placeholder body to be posted to the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterPlaceholders: function (templateId, postParameterPlaceholdersBody, options) {
            return localVarFp.postParameterPlaceholders(templateId, postParameterPlaceholdersBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new template as a draft by default (published_at field set to null). The current user will be set as the creator of the template. Note - requires Application Admin privileges.
         * @summary Create a new draft template (Application Admin only)
         * @param {Array<PostTemplateBody>} postTemplateBody Template body to be posted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTemplate: function (postTemplateBody, options) {
            return localVarFp.postTemplate(postTemplateBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Publishes an existing draft template, making it immutable and available  for use. Note - no request body is required for this endpoint.  Note - requires Application Admin privileges.
         * @summary Publish a draft template (Application Admin only)
         * @param {object} templateId ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishTemplate: function (templateId, options) {
            return localVarFp.publishTemplate(templateId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TemplateApiFactory = TemplateApiFactory;
/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
var TemplateApi = /** @class */ (function (_super) {
    __extends(TemplateApi, _super);
    function TemplateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete an existing asset placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
     * @summary Delete an existing asset placeholder (Application Admin only)
     * @param {TemplateApiDeleteAssetPlaceholderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.deleteAssetPlaceholder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).deleteAssetPlaceholder(requestParameters.templateId, requestParameters.assetPlaceholderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing parameter placeholder from a template.  Note - requires Application Admin privileges. Cannot delete  placeholders that belong to published templates.
     * @summary Delete an existing parameter placeholder (Application Admin only)
     * @param {TemplateApiDeleteParameterPlaceholderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.deleteParameterPlaceholder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).deleteParameterPlaceholder(requestParameters.templateId, requestParameters.parameterPlaceholderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an existing draft template. Note - requires Application  Admin privileges.
     * @summary Delete a draft template (Application Admin only)
     * @param {TemplateApiDeleteTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.deleteTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).deleteTemplate(requestParameters.templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns asset placeholders related to a template
     * @summary Get all asset placeholders related to a template
     * @param {TemplateApiGetAssetPlaceholdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.getAssetPlaceholders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).getAssetPlaceholders(requestParameters.templateId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * By default returns all directions within the database
     * @summary Returns all directions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.getDirections = function (options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).getDirections(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns parameter placeholders related to a template
     * @summary Get all parameter placeholders related to a template
     * @param {TemplateApiGetParameterPlaceholdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.getParameterPlaceholders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).getParameterPlaceholders(requestParameters.templateId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.sortBy, requestParameters.assetPlaceholderId, requestParameters.directionId, requestParameters.optional, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * By default returns all published, non-deleted templates. View drafts with the `show_drafts` query parameter.
     * @summary Returns all templates
     * @param {TemplateApiGetTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.getTemplates = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TemplateApiFp)(this.configuration).getTemplates(requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, requestParameters.sortBy, requestParameters.createdBy, requestParameters.keyAssetTypeId, requestParameters.keyAssetSubTypeId, requestParameters.templateId, requestParameters.projectId, requestParameters.showDrafts, requestParameters.showPublished, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the name / description /count / key status of an existing asset  placeholder. Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
     * @summary Patch an existing asset placeholder (Application Admin only)
     * @param {TemplateApiPatchAssetPlaceholderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.patchAssetPlaceholder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).patchAssetPlaceholder(requestParameters.templateId, requestParameters.assetPlaceholderId, requestParameters.patchAssetPlaceholderBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the direction_id / optional field of an existing parameter placeholder.  Note - requires Application Admin privileges. Cannot patch  placeholders that belong to published templates.
     * @summary Patch an existing parameter placeholder (Application Admin only)
     * @param {TemplateApiPatchParameterPlaceholderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.patchParameterPlaceholder = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).patchParameterPlaceholder(requestParameters.templateId, requestParameters.parameterPlaceholderId, requestParameters.patchParameterPlaceholderBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the name or description of an existing draft template. Note - requires Application Admin  privileges.
     * @summary Update a draft template (Application Admin only)
     * @param {TemplateApiPatchTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.patchTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).patchTemplate(requestParameters.templateId, requestParameters.patchTemplateBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add new asset placeholders for a template to the database.  Note - requires Application Admin privileges.
     * @summary Post a new asset placeholder to a template (Application Admin only)
     * @param {TemplateApiPostAssetPlaceholdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.postAssetPlaceholders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).postAssetPlaceholders(requestParameters.templateId, requestParameters.postAssetPlaceholdersBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add new parameter placeholders for a template to the database.  Note - requires Application Admin privileges.
     * @summary Post a new parameter placeholder to a template (Application Admin only)
     * @param {TemplateApiPostParameterPlaceholdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.postParameterPlaceholders = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).postParameterPlaceholders(requestParameters.templateId, requestParameters.postParameterPlaceholdersBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new template as a draft by default (published_at field set to null). The current user will be set as the creator of the template. Note - requires Application Admin privileges.
     * @summary Create a new draft template (Application Admin only)
     * @param {TemplateApiPostTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.postTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).postTemplate(requestParameters.postTemplateBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Publishes an existing draft template, making it immutable and available  for use. Note - no request body is required for this endpoint.  Note - requires Application Admin privileges.
     * @summary Publish a draft template (Application Admin only)
     * @param {TemplateApiPublishTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    TemplateApi.prototype.publishTemplate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TemplateApiFp)(this.configuration).publishTemplate(requestParameters.templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TemplateApi;
}(base_1.BaseAPI));
exports.TemplateApi = TemplateApi;
